<template>
  <div class="list-content" ref="listContent" :class="this.silenceAndGrey == 1 ? 'gray' : ''">
    <van-list
      v-model="listLoading"
      :finished="finished"
      :finished-text="finishedText"
      @load="nextPage"
      class="product-list"
      :class="[
        list.length > 0 && list[0].insureCost && !list[0].status ? type : '',
        list.length > 0 && !list[0].insureCost && list[0].status ? 'product-list-card-gift' : ''
      ]"
    >
      <div
        class="product-item"
        v-for="(item, index) in list"
        :key="index"
        :class="{ last: index == list.length - 1 }"
        @click="jumpPage(item.url || item.insureProfileUrl)"
      >
        <div class="list-item list-item-separate" :class="item.salesStatus == 1 ? 'unsale-wrap' : ''">
          <div class="content-wrap">
            <div class="img-box">
              <div class="img-children-box" v-if="item.status">
                <div class="logo" :style="{ backgroundImage: 'url(' + item.mobileCover + ')' }"></div>
              </div>
              <div class="img-children-box" v-else>
                <div class="logo" v-if="item.cardImageUrl && type == 'card'" :style="{ backgroundImage: 'url(' + item.cardImageUrl + ')' }"></div>
                <div class="logo" v-else-if="item.listImageUrl" :style="{ backgroundImage: 'url(' + item.listImageUrl + ')' }"></div>
                <div class="logo" v-else-if="item.imageUrl" :style="{ backgroundImage: 'url(' + item.imageUrl + ')' }"></div>
                <div class="logo" v-else-if="item.shortMobileImg" :style="{ backgroundImage: 'url(' + item.shortMobileImg + ')' }"></div>
              </div>
              <div class="company-name">{{ item.companyName }}</div>
            </div>
            <div class="box">
              <div class="top-box">
                <div class="text-box">
                  <div class="text1 text-overflow-2">
                    <img src="@/static/images/product/icon_ys.png" v-if="item.preSale == '1'" class="tag mr" />
                    <img v-if="item.sellType == '经代' && item.salesStatus == 1" src="@/static/images/product/icon_jd_grey.png" class="tag" />
                    <img src="@/static/images/product/icon_wx_grey.png" v-else-if="item.sellType == '网销' && item.salesStatus == 1" class="tag" />
                    <img src="@/static/images/product/icon_jd.png" v-else-if="item.sellType == '经代'" class="tag" />
                    <img src="@/static/images/product/icon_wx.png" v-else-if="item.sellType == '网销'" class="tag" />

                    <template v-if="$tools.isWTS() && item.insureTag.length">
                      <img v-if="item.insureTag.includes('2')" class="tag ml" src="@static/images/product/icon_daitou.png">
                      <img v-if="item.insureTag.includes('4')" class="tag ml" src="@static/images/product/icon_yuyue.png">
                      <img v-if="item.insureTag.includes('5')" class="tag ml" src="@static/images/product/icon_shouji.png">
                      <img v-if="item.insureTag.includes('6')" class="tag ml" src="@static/images/product/icon_dingtou.png">
                      <img v-if="item.insureTag.includes('7')" class="tag ml" src="@static/images/product/icon_wailian.png">
                    </template>
                     <!-- 税优险 -->
                    <img src="@/static/images/product/icon_syx_gray.png" v-if="item.shuiYouXian == '1' && item.salesStatus == 1" class="tag ml" />
                    <img src="@/static/images/product/icon_syx.png" v-else-if="item.shuiYouXian == '1'" class="tag ml" />
                    <span>{{ item.status ? item.title : item.productName }}</span>
                  </div>
                </div>
                <div v-if="item.titleLabel" class="labels">
                  <span v-for="(label, i) in item.titleLabel" :key="i">
                    {{ label }}
                  </span>
                </div>
                <div v-if="item.productDescription" class="desc">
                  <span v-for="(v, index) in item.productDescription.split('\n')" :key="index">{{ v }}<br /></span>
                </div>
              </div>
              <div class="money" v-if="item.insureCost || item.price">
                <span class="num">{{ item.insureCost ? item.insureCost : item.price }}</span>
                <span class="unit">元起</span>
              </div>
            </div>
          </div>
          <div class="box2">
            <div class="info-box">
              <div class="detail-wrap">
                <span class="btn-txt" :class="{ 'disabled': !item.productInformationUrl }" @click.stop="toDetail(item)">产品资料</span>
                <span class="btn-txt" :class="{ 'disabled': !item.insureProfileUrl }" @click.stop="insureProfileUrl(item.insureProfileUrl)">投保流程</span>
              </div>
              <div class="rate-box" v-if="mode != 'index'" @click.stop="openServiceBox(item)">
                <div class="commission-wrap" v-if="item.commissionNum >= 1 && showServiceFee">
                  <div v-if="item.max || item.maxVal">
                    <em>服</em><span>最高{{ item.max || item.maxVal }}%</span>
                  </div>
                </div>
                <div class="activity-num" v-if="item.activityInfoVO && item.activityInfoVO.commission > 0">
                  <div>
                    <em>活</em><span>最高{{ item.activityInfoVO.commission }}%</span>
                  </div>
                </div>
              </div>
              <div
                class="rate-box"
                v-if="mode == 'index' && (item.maxCommission > 0 || item.maxSubsidyCommission > 0) && showServiceFee"
                @click.stop="openServiceBox(item)"
              >
                <div class="commission-wrap">
                  <div v-if="item.maxCommission">
                    <em>服</em><span>最高{{ item.maxCommission }}%</span>
                  </div>
                </div>
                <div class="activity-num" v-if="item.maxSubsidyCommission > 0">
                  <div>
                    <em>活</em><span>最高{{ item.maxSubsidyCommission }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.offlineTime" class="offline-time-box">
            <!-- 2022年11月25日 23:50:46  -->
            <div class="time-box">
              <div class="trangel"></div>
              <img class="icon-laba" src="@static/images/product/icon-laba.png" alt="" />
              本产品将于{{ item.offlineTime | dateFormat('yyyy年MM月dd日 hh:mm') }}下架
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="null" v-if="list.length <= 0 && !listLoading">
      <img class="null-img" src="@static/images/null.png" />
      <span class="null-text">暂无内容</span>
    </div>
    <serviceBox ref="serviceBox"></serviceBox>
  </div>
</template>

<script>
import serviceBox from '@/components/product/serviceBox';
import { pageTools, common } from '@/api/mixins';
export default {
  mixins: [pageTools, common],
  components: { serviceBox },
  props: {
    url: null,
    data: null,
    mode: null,// index: 首页热销, product: 产品页
    type: null,
    showServiceFee: null,
    silenceAndGrey: null,
    params: {},
    classifyList: [],
    productSourceList: [],
    productSalesList: []
  },
  data() {
    return {
      list: [],
      isLoading: false
    };
  },
  watch: {
    data: {
      handler: function (val, oldVal) {
        if (this.data) {
          this.listLoading = false;
          this.finished = true;
          this.finishedText = '';
        }
        if (this.data && this.data.length) {
          this.finishedText = '暂无更多数据';
          this.list = JSON.parse(JSON.stringify(this.data));
          this.list.forEach(item => {
            if (item.titleLabel) {
              item.titleLabel = item.titleLabel.split(',');
            }
          });
        } else {
          this.list = [];
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$refs.listContent.scrollTop = 0;
  },
  methods: {
    toDetail(item) {
      if (!item.productInformationUrl) {
        return this.$notice.msg('该产品暂无产品资料');
      } else {
        location.href = item.productInformationUrl;
      }
    },
    insureProfileUrl(url) {
      if (!url) return this.$notice.msg('该产品暂无投保流程');
      location.href = url;
    },
    jumpPage(url) {
      if (!url) return this.$notice.msg('该产品无详情');
      location.href = url;
    },
    openServiceBox(item) {
      this.$refs.serviceBox.open(item);
    },
    init(url) {
      this.pageNum = 1;
      this.initListAjax(url);
    },
    // 设置自定义参数
    setListParams(params) {
      let data = JSON.parse(JSON.stringify(this.params));
      console.log(data);
      let arr = ['salesStatus', 'sellType', 'supplierIds', 'insureAreaCodes'];
      for (const key in data) {
        if (arr.includes(key)) {
          if (key == 'salesStatus' && this.productSalesList.length == data[key].length) {
            params[key] = '';
          } else if (key == 'sellType' && this.classifyList.length == data[key].length) {
            params[key] = data[key];
          } else if (key == 'supplierIds') {
            params[key] = this.productSourceList.length == data[key].length ? [] : data[key];
          } else if (key == 'insureAreaCodes' && data[key].length > 0) {
            let arr = data[key].join().split(',');
            params[key] = [...new Set(arr)];
          } else {
            params[key] = data[key].join();
          }
        } else {
          params[key] = data[key];
        }
      }
      if (data.typeId) {
        params.firstTag = data.typeId;
      }
      if (data.typeId == -1) {
        //一级菜单赠险
        params.firstTag = 0;
      }
      if (!data.typeId) {
        //一级菜单全部
        params.firstTag = '';
      }
      delete params.typeId;
    },
    suolve(str, sub_length) {
      var sub_length = parseInt(sub_length);
      console.log(sub_length);
      var temp1 = str.replace(/[^\x00-\xff]/g, '**'); //精髓
      var temp2 = temp1.substring(0, sub_length);
      //找出有多少个*
      var x_length = temp2.split('*').length - 1;
      var hanzi_num = x_length / 2;
      sub_length = sub_length - hanzi_num; //实际需要sub的长度是总长度-汉字长度
      var res = str.substring(0, sub_length);
      if (sub_length < str.length) {
        var end = res + '...';
      } else {
        var end = res;
      }
      return end;
    },
    listCallback() {
      this.$nextTick(() => {
        const domList = document.getElementsByClassName('text1');
        const domList1 = document.getElementsByClassName('box');
        this.list.forEach((item, i) => {
          const dom = domList[i];
          const h = dom.clientHeight;
          if (h < 30) {
            // console.log(domList1[i].querySelectorAll('.desc'));
            if (domList1[i].querySelectorAll('.desc').length) {
              domList1[i].querySelectorAll('.desc')[0].className = 'desc text-overflow-2';
            }
          }
          dom.className = 'text1 text-overflow-2';
          if (item.titleLabel && typeof item.titleLabel == 'string') {
            item.titleLabel = item.titleLabel.split(',');
          }
          if(item.insureTag && typeof item.insureTag == 'string'){
            item.insureTag = JSON.parse(item.insureTag)
          }
          if (h != dom.clientHeight) {
            this.$set(item, 'hasTwoTitle', true);
          }
        });
      });
    },
    toList() {
      this.$router.push({ path: '/apps/order/giftList' });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './list.scss';
</style>
